import axios from 'axios';
import { clearStorage } from './utils/localStorage';

export const BASE_API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Auto logout on 401 (expired/invalid token) — skip if already on auth pages
BASE_API.interceptors.response.use(
  (response) => response,
  (error) => {
    const authPaths = ['/signin', '/signup', '/forgot-password', '/linkedin'];
    const isAuthPage = authPaths.some((p) => window.location.pathname.startsWith(p));
    if (error?.response?.status === 401 && !isAuthPage) {
      clearStorage();
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

export const clientConfig = process.env.REACT_APP_CLIENT;
export const clientSecret = process.env.REACT_APP_CLIENT_SECRET;